import styled from "styled-components";

export const FestivalEventInfoWrapper = styled.div`
  width: calc(100% - 32px);
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 8px;
  padding: 20px 12px 30px;
  position: relative;
  left: 16px;
  top: -18px;
  z-index: 1;
  background: #fff;

  > .title {
    font-weight: 700;
    font-size: 16px;
    color: #121212;
    padding-bottom: 8px;
    border-bottom: 1px solid #dedede;
  }
`;

export const FestivalEventInfoContent = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 8px;
`;

export const FestivalEventInfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .name {
    font-weight: 500;
    font-size: 14px;
    color: #808080;
  }

  > .value {
    font-weight: 700;
    font-size: 14px;
    color: #121212;
  }
`;
